import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BundleMixin from '@/helpers/vue_mixins/v2/BundleMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { required } from 'vuelidate/lib/validators';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import { CommissionType } from '@/helpers/entities/enums/v2/CommissionType';
import NumericInput from '@/components/v2/NumericInput.vue';
import createAndUpdateAffiliateManagerSetting from '@/plugins/graphql/mutations/v2/affiliate/create-and-update-affiliate-manager-setting.gql';
import AffiliateSettingsConfirm from '@/components/v2/AffiliateSettingsConfirm.vue';
let AffiliateSettingsForm = class AffiliateSettingsForm extends Mixins(BundleMixin, RouterParamsAppMixin, ViewportSizeMixin, FormMixin, FormValidationsMixin) {
    constructor() {
        super(...arguments);
        this.openConfirmation = false;
        this.mutationRequestOnFlight = false;
    }
    get commissionTypes() {
        return [selectOptionBuilder(CommissionType.Percentage, 'Percentage of sale')];
        // Use this when we will be enabling absolute values for affilaite commissions:
        // return [
        //   selectOptionBuilder(CommissionType.Percentage, 'Percentage of sale'),
        //   selectOptionBuilder(CommissionType.Absolute, 'Absolute'),
        // ];
    }
    get commissionTypeIsPercentage() {
        return this.form.commissionType === CommissionType.Percentage;
    }
    async onCreateAndUpdateAffiliateManagerSetting() {
        if (!this.enableAffiliate) {
            this.errorNotification('Store Affiliate Settings is Disabled');
            return;
        }
        this.mutationRequestOnFlight = true;
        this.$apollo
            .mutate({
            mutation: createAndUpdateAffiliateManagerSetting,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    commissionType: this.form.commissionType,
                    commissionAmount: this.form.commissionAmount,
                },
            },
        })
            .then(() => {
            this.successNotification(`Successfully Updated Affiliate Settings`);
            this.$emit('disable-edit-mode');
        })
            .catch(() => {
            this.errorNotification('Error Updating Affiliate Settings');
        })
            .finally(() => {
            this.mutationRequestOnFlight = false;
            this.closeConfirmationDialog();
        });
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.openConfirmationDialog();
        }
    }
    onCancel() {
        if (this.hasExistingSettings) {
            this.$emit('disable-edit-mode');
        }
        else {
            this.$router.push({ name: 'ecommerce-overview' });
        }
    }
    openConfirmationDialog() {
        this.openConfirmation = true;
    }
    closeConfirmationDialog() {
        this.openConfirmation = false;
    }
};
__decorate([
    Prop({ type: Object, default: false })
], AffiliateSettingsForm.prototype, "form", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], AffiliateSettingsForm.prototype, "queryRequestOnFlight", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AffiliateSettingsForm.prototype, "hasExistingSettings", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AffiliateSettingsForm.prototype, "enableAffiliate", void 0);
AffiliateSettingsForm = __decorate([
    Component({
        components: {
            ActionButton,
            BaseSubtitle,
            PageTitle,
            BaseTextField,
            NumericInput,
            AffiliateSettingsConfirm,
        },
        validations: {
            form: {
                commissionType: {
                    required,
                },
                commissionAmount: {
                    required,
                },
            },
        },
    })
], AffiliateSettingsForm);
export default AffiliateSettingsForm;
